import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { myHeaders } from "./CommonHeader";
import { SubmitLogin } from "./LoginRedux";

export const CreateOTP = createAsyncThunk(
  "CreateOTP",
  async (data1, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        process.env.REACT_APP_BackEndIP+"/OTP",
        {
          Email: data1["Email"],
          // orders: [1, 2, 3],
          // photo: document.querySelector('#fileInput').files
        },
        {
          headers: myHeaders(),
        }
      );
      return data;
    } catch (error) {
      // if(error.code === "ERR_NETWORK"){console.log("aaaaaaaaaaaaaaaaaaaaaaaaaa")}

      console.error("!!!", error);
      return rejectWithValue("ERROR");
    }
  }
);

const OTPSlice = createSlice({
  name: "OTP",
  initialState: {
    OTPResponce: ["hide", ""],
  },
  reducers: {
    OTPReset(state, action) {
      state.OTPResponce = ["hide", ""];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(CreateOTP.fulfilled, (state, action) => {
        state.OTPResponce = ["", "OTP Sent Successful"];
      })
      .addCase(CreateOTP.pending, (state, action) => {
        state.OTPResponce = ["", "OTP Sending"];
      })
      .addCase(CreateOTP.rejected, (state, action) => {
        state.OTPResponce = ["", "OTP Error Try Again Later"];
      })
      .addCase(SubmitLogin.fulfilled, (state, action) => {
        state.OTPResponce = ["hide", ""];
      })
      .addCase(SubmitLogin.rejected, (state, action) => {
        state.OTPResponce = ["hide", ""];
      });
  },
});
export const { OTPReset } = OTPSlice.actions;
export default OTPSlice.reducer;
